import { Injectable } from '@angular/core';
import { TagState } from 'src/app/_model/tag-state';

@Injectable()
export abstract class TagStatesDaoService {
    abstract persistLocalTagStates(tagStates: TagState[]): Promise<void>;
    abstract loadLocalTagStates(): Promise<TagState[]>;
}